import { throwApiError } from '@/shared/utils/apiResponse';
import { apiGet } from '@/shared/utils/requestBuilder';

import type {
  AuditoriaProcessoListResult,
  FetchAuditoriaProcessoArgs,
  FiltrosDisponiveisAuditoria,
} from '../../types/auditoriaProcesso';

const unwrap = <T>(body: unknown): T => {
  if (typeof body === 'object' && body !== null && 'data' in body) {
    return (body as { data: T }).data;
  }
  return body as T;
};

const jsonOk = async <T>(response: Response, fallbackMsg: string): Promise<T> => {
  if (!response.ok) await throwApiError(response, fallbackMsg);
  const body = (await response.json()) as unknown;
  return unwrap<T>(body);
};

const queryDaBusca = (args: FetchAuditoriaProcessoArgs): Record<string, string | number> => {
  const query: Record<string, string | number> = { page: args.page, limit: args.limit };
  if (args.busca?.trim()) query.busca = args.busca.trim();
  if (args.categoria?.length) query.categoria = args.categoria.join(',');
  if (args.tipoAcao?.length) query.tipoAcao = args.tipoAcao.join(',');
  if (args.usuarioId) query.usuarioId = args.usuarioId;
  if (args.de) query.de = args.de;
  if (args.ate) query.ate = args.ate;
  return query;
};

const rotaBase = (processoArbitralId: string): string =>
  `/admin/arbitral/processos/${encodeURIComponent(processoArbitralId)}/auditoria`;

export const auditoriaProcessoService = {
  listar: async (args: FetchAuditoriaProcessoArgs): Promise<AuditoriaProcessoListResult> => {
    const response = await apiGet(rotaBase(args.processoArbitralId), queryDaBusca(args));
    return jsonOk<AuditoriaProcessoListResult>(
      response,
      'Erro ao carregar a auditoria do processo',
    );
  },

  listarFiltros: async (processoArbitralId: string): Promise<FiltrosDisponiveisAuditoria> => {
    const response = await apiGet(`${rotaBase(processoArbitralId)}/filtros`);
    return jsonOk<FiltrosDisponiveisAuditoria>(
      response,
      'Erro ao carregar os filtros da auditoria',
    );
  },
};
